import React, { useCallback, useState, useEffect } from "react";
import { TextInput, PrimaryButton, AleartModalButton } from "../../components/UIkit";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, getUserId } from "../../reducks/users/selectors";
import { OrganizerHeader } from "../../components/header";
import { fechCurrentUser, saveUser } from "../../reducks/users/operations";
import { push } from "connected-react-router";

const ProfileEdit = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const currentUser = getCurrentUser(selector);
  const isBoothEditing = true;
  const isOpusEditing = true;

  const [name, setName] = useState(""),
    [genre, setGenre] = useState(""),
    [intro, setIntro] = useState("");

  const inputName = useCallback(
    (event) => {
      setName(event.target.value);
    },
    [setName]
  );

  const inputGenre = useCallback(
    (event) => {
      setGenre(event.target.value);
    },
    [setGenre]
  );

  const inputIntro = useCallback(
    (event) => {
      setIntro(event.target.value);
    },
    [setIntro]
  );

  const validateRequiredInput = (...args) => {
    let isBlank = false;
    for (let i = 0; i < args.length; i = (i + 1) | 0) {
      if (args[i] === "") {
        isBlank = true;
      }
    }
    return isBlank;
  };

  const submitProfile = () => {
    const isBlank = validateRequiredInput(name, genre, intro);
    console.log(isBlank);
    if (isBlank) {
      alert("未記入での保存はできません");
      return false;
    } else {
      dispatch(saveUser(uid, name, genre, intro));
    }
  };

  const fechUser = () => {
    setName(currentUser.username);
    setGenre(currentUser.genre);
    setIntro(currentUser.intro);
  };

  useEffect(() => {
    dispatch(fechCurrentUser(uid));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fechUser();
    // eslint-disable-next-line
  }, [currentUser]);

  return (
    <section>
      <div className="common-container">
        <div className="common-container__header--inner center-box">
          <OrganizerHeader isBoothEditing={isBoothEditing} isOpusEditing={isOpusEditing} />
          <div className="mypage-container">
            <div className="spacer-box--l"></div>
            <h2 className="form-text__headline--l center">プロフィール編集</h2>
            <div>
              <TextInput
                fullWidth={true}
                label={"名前"}
                multiline={false}
                required={true}
                onChange={inputName}
                rows={1}
                value={name ?? ""}
                type={"text"}
              />
              <TextInput
                fullWidth={true}
                label={"ジャンル"}
                multiline={false}
                required={true}
                onChange={inputGenre}
                rows={1}
                value={genre ?? ""}
                type={"text"}
              />
              <TextInput
                fullWidth={true}
                label={"自己紹介"}
                multiline={true}
                required={true}
                onChange={inputIntro}
                rows={5}
                value={intro ?? ""}
                type={"text"}
              />
              <div className="spacer-box--l" />
              <div className="center">
                <PrimaryButton label={"保存"} onClick={() => submitProfile()} />

                <div className="spacer-box--m" />
                <AleartModalButton
                  title="保存されいない内容は消去されます"
                  text="よろしいですか？"
                  onClick={() => dispatch(push(`/organizer/${uid}`))}
                  label="TOPへ戻る"
                  className="top-back-btn"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileEdit;
